import { Container } from '$app/shared/components/Container';
import styled from 'styled-components';
import { Button } from 'antd';

export const ContainerStyled = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const DivStyled = styled.div`
height: 100%;
margin: 0;
background: #fbfbfb;

.ant-btn-primary {
  margin-bottom: 8px;
}
`;


export const ButtonsContainer = styled.div`
	padding: 20 40px;
	display: flex;
`;

export const NewButton = styled(Button)`
	width: 50%;
	margin: 10px 20px;	
`;

export const SaveButton = styled(Button)`
	width: 50%;
	margin: 10px 20px;
`;
 